import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Gym } from '../model/gym';

@Injectable({
  providedIn: 'root',
})
export class GymFinderServiceV2 {
  constructor(private httpClient: HttpClient) {}

  public getGym(serverGymsGymId: string): Observable<Gym> {
    const url = `/upstream/gymfinder/internal/admin/v2/gym/${serverGymsGymId}`;
    return this.httpClient.get<Gym>(url, { withCredentials: true });
  }
}
